import { render, staticRenderFns } from "./ProductsReportTableMobile.vue?vue&type=template&id=f78ec01e&scoped=true"
import script from "./ProductsReportTableMobile.vue?vue&type=script&lang=js"
export * from "./ProductsReportTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78ec01e",
  null
  
)

export default component.exports